export default class ValidationError extends Error {
    public constructor(public errors: any[]) {
        super()
    }
}
